import axios from 'axios';

export function getAutocheckMileageReport(VIN, referenceId, product, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const reference = referenceId || '';
  const url = `${config.getMileageReportService}?VIN=${VIN}&referenceId=${reference}&product=${product}`;

  return dispatch => dispatch({
    type: 'AUTOCHECK_MILEAGE_REPORT_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearAutocheckMileageReport() {
  return {
    type: 'AUTOCHECK_MILEAGE_REPORT_CLEAR',
    payload: ''
  };
}


// WEBPACK FOOTER //
// ./src/actions/getMileageReport.js